document.addEventListener("DOMContentLoaded", function () {
  // Initialize the cart functionality
  initializeCart();
});

function initializeCart() {
  const cartSection = document.querySelector("[data-cart-section]");
  if (!cartSection) return;

  // Set up event delegation for cart actions
  cartSection.addEventListener("click", handleCartActions);

  // Set up input event listeners for quantity changes
  const quantityInputs = cartSection.querySelectorAll("[data-quantity-input]");
  quantityInputs.forEach((input) => {
    input.addEventListener("change", handleQuantityChange);
  });

  // Add event listener for checkout button
  const checkoutButton = cartSection.querySelector(".checkout-button");
  if (checkoutButton) {
    checkoutButton.addEventListener("click", handleCheckout);
  }
}

function handleCartActions(event) {
  const target = event.target;

  // Check if the target is SVG or path element and get the button parent
  let actionElement = target;
  if (target.tagName === "svg" || target.tagName === "path") {
    actionElement = target.closest("button");
  }

  // Handle quantity adjustment buttons
  if (actionElement.matches('[data-action="increase"]')) {
    const input = actionElement.parentElement.querySelector(
      "[data-quantity-input]"
    );
    updateQuantity(input, parseInt(input.value) + 1);
  } else if (actionElement.matches('[data-action="decrease"]')) {
    const input = actionElement.parentElement.querySelector(
      "[data-quantity-input]"
    );
    if (parseInt(input.value) > 1) {
      updateQuantity(input, parseInt(input.value) - 1);
    } else {
      // If quantity would be less than 1, remove the item
      const cartItem = actionElement.closest("[data-cart-item]");
      removeCartItem(cartItem.dataset.id);
    }
  }

  // Handle remove item button
  if (actionElement.matches("[data-remove-item]")) {
    const cartItem = actionElement.closest("[data-cart-item]");
    removeCartItem(cartItem.dataset.id);
  }
}

function handleQuantityChange(event) {
  const input = event.target;
  const newQuantity = parseInt(input.value);

  // Ensure quantity is at least 1
  if (newQuantity < 1) {
    const cartItem = input.closest("[data-cart-item]");
    removeCartItem(cartItem.dataset.id);
  } else {
    updateQuantity(input, newQuantity);
  }
}

function updateQuantity(inputElement, newQuantity) {
  if (newQuantity < 1) return;

  const cartItem = inputElement.closest("[data-cart-item]");
  const itemId = cartItem.dataset.id;

  // Show loading state
  cartItem.classList.add("loading");

  // Update the cart using Fetch API and Section Rendering API
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: itemId,
      quantity: newQuantity,
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      // Update the cart section using the Section Rendering API
      updateCartSection();
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
      cartItem.classList.remove("loading");
      // Reset the input to its previous value
      inputElement.value = inputElement.defaultValue;
    });
}

function removeCartItem(itemId) {
  // Show loading state
  const cartItem = document.querySelector(
    `[data-cart-item][data-id="${itemId}"]`
  );
  if (cartItem) {
    cartItem.classList.add("loading");
  }

  // Update the cart using Fetch API
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: itemId,
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      // Update the cart section using the Section Rendering API
      updateCartSection();
    })
    .catch((error) => {
      console.error("Error removing item from cart:", error);
      if (cartItem) {
        cartItem.classList.remove("loading");
      }
    });
}

function updateCartSection() {
  // Use the Shopify Section Rendering API to update the cart section
  fetch(window.location.pathname + "?section_id=custom-cart")
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, "text/html");
      const newCartSection = newDocument.querySelector("[data-cart-section]");

      if (newCartSection) {
        const currentCartSection = document.querySelector(
          "[data-cart-section]"
        );
        currentCartSection.innerHTML = newCartSection.innerHTML;

        // Re-initialize event listeners
        initializeCart();
      }
    })
    .catch((error) => {
      console.error("Error updating cart section:", error);
    });
}

function handleCheckout(event) {
  event.preventDefault();

  // Redirect to checkout
  window.location.href = "/checkout";
}

// Add CSS animation for loading state
const style = document.createElement("style");
style.textContent = `
    .custom-cart-item.loading {
      opacity: 0.5;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
  `;
document.head.appendChild(style);
